import { render } from "./ResourcesGoal3.vue?vue&type=template&id=0afc7a33"
import script from "./ResourcesGoal3.vue?vue&type=script&lang=js"
export * from "./ResourcesGoal3.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__